import { render, staticRenderFns } from "./ReportLocation.vue?vue&type=template&id=f8976840&scoped=true&"
import script from "./ReportLocation.vue?vue&type=script&lang=ts&"
export * from "./ReportLocation.vue?vue&type=script&lang=ts&"
import style0 from "./ReportLocation.vue?vue&type=style&index=0&id=f8976840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8976840",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
